import session from '@/shared/session'

// initial state
const state = {
	current : {},
}

// getters
const getters = {}
const data = {}
// actions
const actions = {
	equipmentOverview ({},data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/equipments/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	equipmentDetail ({},data) {
		return new Promise((resolve, reject) => {
			session.get(`/api/workouts/equipments/${data.id}/`, {
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	equipmentCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.post('api/workouts/equipments/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	equipmentUpdate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.put(`/api/workouts/equipments/${data.id}/`, data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	equipmentRemove ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/equipments/partial_update_delete/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	filterEquipment ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/equipments/get_filtered_equipment/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
    equipmentStatusUpdate ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/equipments/partial_update_status/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
}

// mutations
const mutations = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
